window.Vue = require('vue').default;
import Vuex from 'vuex';

import { modalModule } from 'vuex-modal';
import ServiceModule from './module/services.vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
		services: ServiceModule,
		modal: modalModule
    }
});

export default store;
